import { Button, MobileStepper, SvgIconProps } from "@mui/material";
import { KeyboardArrowLeft, KeyboardArrowRight } from "@mui/icons-material";

interface IParams {
    activeStep: number;
    fontSizeArrow?: SvgIconProps["fontSize"];
    stepsLength: number;
    handleStepChange(step: number): void;
}

export const Stepper = (props: IParams) => {
    const { handleStepChange, stepsLength, activeStep, fontSizeArrow } = props;

    return (
        <MobileStepper
            activeStep={activeStep}
            backButton={
                <Button
                    aria-label="Back"
                    color="secondary"
                    disabled={activeStep === 0}
                    size="small"
                    onClick={() => handleStepChange(activeStep - 1)}
                >
                    <KeyboardArrowLeft fontSize={fontSizeArrow} />
                </Button>
            }
            nextButton={
                <Button
                    aria-label="Next"
                    color="secondary"
                    disabled={activeStep + 1 === stepsLength}
                    size="small"
                    onClick={() => handleStepChange(activeStep + 1)}
                >
                    <KeyboardArrowRight fontSize={fontSizeArrow} />
                </Button>
            }
            position="static"
            steps={stepsLength}
            variant="dots"
        />
    );
};
